const PREFIX = "sfPendingInvChange:";

export const pendingChangeKey = (changeMapId: string) => `${PREFIX}${changeMapId}`;

export const writePendingChange = (changeMapId: string, value: unknown) => {
	localStorage.setItem(pendingChangeKey(changeMapId), String(value));
};

export const removePendingChange = (changeMapId: string) => {
	localStorage.removeItem(pendingChangeKey(changeMapId));
};

export const readAllPendingChanges = (): Map<string, string> => {
	const map = new Map<string, string>();
	for (let i = 0; i < localStorage.length; i++) {
		const key = localStorage.key(i);
		if (!key || !key.startsWith(PREFIX)) continue;
		const value = localStorage.getItem(key);
		if (value != null) map.set(key.slice(PREFIX.length), value);
	}
	return map;
};
